import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { patch, post } from 'helpers/requests';
import { apelable } from 'helpers/helpers';
import { Button, Col, Input, Label, FormGroup } from 'reactstrap';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BASE_URL, API, ESTADOS_OPORTUNIDAD } from 'CONST';
import CheckModal from '../shared/CheckModal';
import WarningModal from '../UI/WarningModal';
import AvanzarOportunidadConfirmationModal from './AvanzarOportunidadConfirmationModal';

const OportunidadRechazadaSection = ({ id, fullData, estadosOportunidad, observaciones }) => {
  const history = useHistory();
  const [observacion, setObservacion] = useState('');
  const [observacionesEstado, setObservacionesEstado] = useState([]);
  const [editableSection, setEditableSection] = useState(false);
  const [confirmMsg, setConfirmMsg] = useState('');
  const [showApelacionModal, setShowApelacionModal] = useState(false);
  const [showAceptacionModal, setShowAceptacionModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const editableStates = [ESTADOS_OPORTUNIDAD.rechazado];

  useEffect(() => {
    if (
      fullData &&
      fullData.estado &&
      editableStates.includes(fullData.estado.nemotecnico) &&
      apelable(fullData.fecha_rechazo) &&
      !fullData.cliente_acepta_rechazo
    ) {
      setEditableSection(true);
    }
  }, [fullData]);

  useEffect(() => {
    if (observaciones) {
      setObservacionesEstado(
        observaciones.filter((obs) => obs.estado.nemotecnico === ESTADOS_OPORTUNIDAD.rechazado),
      );
    }
  }, [observaciones, fullData]);

  const postObservacion = () => {
    if (observacion) {
      const bodyObservacion = {
        oportunidad_id: id,
        estado_id: estadosOportunidad.find((e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.rechazado)
          .id,
        observacion,
      };
      post(`${BASE_URL}${API.observacionesOportunidad}`, bodyObservacion)
        .then(() => {
          setShowUpdateModal(true);
        })
        .catch(() => {
          setShowErrorModal(true);
        });
    }
  };

  const apelarSolicitud = () => {
    setLoading(true);
    const body = {
      estado_id: estadosOportunidad.find(
        (e) => e.nemotecnico === ESTADOS_OPORTUNIDAD.suscriptorAsignado,
      ).id,
    };
    patch(`${BASE_URL}${API.oportunidadesLinea}${id}/`, body)
      .then(() => {
        postObservacion();
        setShowUpdateModal(true);
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setShowApelacionModal(false);
        setLoading(false);
        setConfirmMsg("Solicitud apelada. Oportunidad volvió al estado 'Información Inicial'.");
      });
  };

  const aceptarRechazo = () => {
    setLoading(true);
    const body = {
      cliente_acepta_rechazo: true,
    };
    patch(`${BASE_URL}${API.oportunidadesLinea}${id}/`, body)
      .then(() => {
        postObservacion();
        setShowUpdateModal(true);
      })
      .catch(() => {
        setShowErrorModal(true);
      })
      .finally(() => {
        setShowAceptacionModal(false);
        setLoading(false);
        setConfirmMsg('Cliente aceptó el rechazo de la solicitud.');
      });
  };

  return (
    <div>
      {/* Motivo rechazo */}
      <FormGroup row>
        <Col sm={2}>
          <Label>Motivo del Rechazo</Label>
        </Col>
        <Col sm={4}>
          <Input defaultValue={fullData.motivo_rechazo.descripcion} disabled />
        </Col>
      </FormGroup>
      {/* Observaciones */}
      <FormGroup row>
        <Col sm={2}>
          <Label>Observaciones</Label>
        </Col>
        <Col>
          <Input
            id="observacion-info-inicial"
            type="textarea"
            value={
              !editableSection && observacionesEstado.length > 0
                ? observacionesEstado[0].observacion
                : observacion || ''
            }
            onChange={(event) => setObservacion(event.target.value)}
            rows="3"
            disabled={!editableSection}
          />
        </Col>
      </FormGroup>
      {observacionesEstado.slice(!editableSection).map((obs) => {
        return (
          <FormGroup row key={obs.id}>
            <Col sm={2} />
            <Col>
              <Input type="textarea" value={obs.observacion} rows="3" disabled />
            </Col>
          </FormGroup>
        );
      })}
      {/* Botones */}
      {editableSection && (
        <div className="button-container d-flex justify-content-end">
          <Button
            style={{ marginRight: 25 }}
            className="btn btn-secondary warning-cancel no-bold"
            onClick={() => setShowApelacionModal(true)}
            disabled={showApelacionModal || showAceptacionModal}
          >
            {loading && showApelacionModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Cliente desea apelar'
            )}
          </Button>
          <Button
            className="btn btn-secondary warning-accept no-bold"
            onClick={() => setShowAceptacionModal(true)}
            disabled={showApelacionModal || showAceptacionModal}
          >
            {loading && showAceptacionModal ? (
              <FontAwesomeIcon spin={loading} icon={faSpinner} />
            ) : (
              'Cliente acepta rechazo'
            )}
          </Button>
        </div>
      )}
      <AvanzarOportunidadConfirmationModal
        openModal={showApelacionModal}
        setOpenModal={setShowApelacionModal}
        avanzarOportunidad={apelarSolicitud}
        loading={loading}
        mensajeModal="¿Está seguro que cliente desea APELAR esta oportunidad?"
      />
      <AvanzarOportunidadConfirmationModal
        openModal={showAceptacionModal}
        setOpenModal={setShowAceptacionModal}
        avanzarOportunidad={aceptarRechazo}
        loading={loading}
        mensajeModal="¿Está seguro que cliente ACEPTA EL RECHAZO de esta oportunidad?"
      />
      <CheckModal
        isOpen={showUpdateModal}
        toggle={() => history.push('/garantia/oportunidades')}
        handleOk={() => history.push('/garantia/oportunidades')}
        okBtnText="OK"
        confirmMsg={confirmMsg}
      />
      <WarningModal
        isOpen={showErrorModal}
        toggle={() => setShowErrorModal(false)}
        handleClearError={() => setShowErrorModal(false)}
        errorMsg="Ha ocurrido un error."
        loading={false}
        onlyCancelButton
      />
    </div>
  );
};

OportunidadRechazadaSection.propTypes = {
  id: PropTypes.string,
  fullData: PropTypes.shape({
    motivo_rechazo: PropTypes.shape({
      descripcion: PropTypes.string,
      id: PropTypes.number,
      codigo: PropTypes.number,
    }),
    estado: PropTypes.shape({
      descripcion: PropTypes.string,
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
    }),
    id: PropTypes.number,
    fecha_rechazo: PropTypes.string,
    cliente_acepta_rechazo: PropTypes.bool,
  }),
  estadosOportunidad: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nemotecnico: PropTypes.string,
      descripcion: PropTypes.string,
    }),
  ),
  observaciones: PropTypes.arrayOf(
    PropTypes.shape({
      actualizacion_ts: PropTypes.string,
      creacion_ts: PropTypes.string,
      estado: PropTypes.shape({
        descripcion: PropTypes.string,
        id: PropTypes.number,
        nemotecnico: PropTypes.string,
      }),
      id: PropTypes.number,
    }),
  ),
};

OportunidadRechazadaSection.defaultProps = {
  id: null,
  fullData: null,
  estadosOportunidad: [],
  observaciones: [],
};

export default OportunidadRechazadaSection;
